export default __webpack_public_path__ + "static/media/INEX.9d73361e.svg";